import React from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { push } from "react-router-redux";
import { Icon } from "MODULES/shared/components";
import { globalPartsSearch } from "MODULES/parts/actions";
import AutoComplete from "APP_ROOT/Nav/GlobalSearch/AutoComplete";

function GlobalSearch({ search, navigate }) {
  return (
    <div className="navbar-right">
      <div
        className="navbar-form"
        role="search"
        style={{ marginBottom: 0, paddingBottom: 0 }}
      >
        <div className="input-group">
          <AutoComplete
            key="global-part-search"
            hasId={false}
            search={search}
            onSelect={navigate}
            format={() => ""} // This will ensure input value is cleared out when item is selected
            selectOnBlur={false}
            renderItem={(item, isHighlighted) => (
              <li key={item.id} className={isHighlighted ? "selected" : ""}>
                <div>
                  <strong>
                    {item.part_number} - {item.description}
                  </strong>
                </div>
                <div className="text-muted">
                  {item.alternate_part_numbers && (
                    <span>
                      <strong>ALTS:</strong> {item.alternate_part_numbers}
                    </span>
                  )}
                </div>
              </li>
            )}
            placeholder="Parts Details Search"
            className="global-autocomplete"
          />
          <div className="input-group-btn">
            <button className="btn btn-default" type="button">
              <Icon name="search" fixed />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

GlobalSearch.propTypes = {
  search: T.func.isRequired,
  navigate: T.func.isRequired
};

export default connect(undefined, dispatch => ({
  search: filter => dispatch(globalPartsSearch(filter)),
  navigate: part => {
    if (part) {
      dispatch(push(`/parts/${part.uuid}`));
    }
  }
}))(GlobalSearch);



// WEBPACK FOOTER //
// ./app/Nav/GlobalSearch/GlobalSearch.jsx